import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Download } from "lucide-react";
import { fetchActivities } from "@/lib/api";

const Activities = () => {
  const [activities, setActivities] = useState([]);
  useEffect(() => {
    fetchActivities().then(setActivities).catch(() => {});
  }, []);

  return (
    <section
      id="activities"
      className="relative mx-auto flex min-h-[100svh] w-full max-w-7xl flex-col justify-center px-4 py-28 sm:px-6 sm:py-36"
      data-testid="activities-section"
    >
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-xs font-bold uppercase tracking-[0.3em] text-[#9333EA]"
      >
        Activities
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.08 }}
        className="mt-3 max-w-xl font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl"
      >
        Print, colour, play, pray.
      </motion.h2>

      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {activities.map((a, i) => (
          <motion.div
            key={a.activity_id}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
            whileHover={{ y: -5 }}
            className="group flex flex-col justify-between rounded-3xl border border-[#E2DDD0] bg-white p-6 shadow-[0_10px_30px_-5px_rgba(234,179,8,0.1)] transition-shadow hover:shadow-[0_14px_28px_rgba(0,0,0,0.06)]"
            data-testid={`activity-card-${a.activity_id}`}
          >
            <div>
              <span
                className="inline-block rounded-full px-3 py-1 text-xs font-bold text-white"
                style={{ backgroundColor: a.color }}
              >
                {a.kind}
              </span>
              <h3 className="mt-3 font-display text-lg font-bold leading-snug text-slate-900">{a.title}</h3>
              <p className="mt-1.5 text-sm text-slate-500 leading-relaxed">{a.desc}</p>
            </div>
            <button
              data-testid={`activity-download-${a.activity_id}`}
              className="mt-5 inline-flex items-center gap-2 self-start rounded-full border-2 border-[#E2DDD0] px-4 py-2 text-sm font-bold text-slate-600 transition-all hover:border-slate-900 hover:bg-slate-900 hover:text-white"
            >
              <Download className="h-4 w-4" />
              Download
            </button>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Activities;
